import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Navbar Menu
import { PageHomeComponent } from './pages/page-home/page-home.component';
import { PageSearchComponent } from './pages/page-search/page-search.component';
import { PageSettingComponent } from './pages/page-setting/page-setting.component';
import { PageHelpComponent } from './pages/page-help/page-help.component';
//import { AngularFireAuthGuard, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { AngularFireAuthGuard, loggedIn, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { PeopleLoginComponent } from './pages/people-login/people-login.component';
import { PeopleAddComponent } from './pages/people-add/people-add.component';
import { BusinessListComponent } from './pages/business-list/business-list.component';
import { BusinessDetailComponent } from './pages/business-detail/business-detail.component';
import { BusinessCategoryListComponent } from './pages/business-category-list/business-category-list.component';
import { PeopleDetailsComponent } from './pages/people-details/people-details.component';
import { PeopleUpdateDetailsComponent } from './pages/people-update-details/people-update-details.component';
import { SponsorListComponent } from './pages/sponsor-list/sponsor-list.component';
import { SponsorDetailComponent } from './pages/sponsor-detail/sponsor-detail.component';
import { GovernmentListComponent } from './pages/government-list/government-list.component';
import { GovernmentDetailComponent } from './pages/government-detail/government-detail.component';
import { GovernmentCategoryListComponent } from './pages/government-category-list/government-category-list.component';
import { TourpackageListComponent } from './pages/tourpackage-list/tourpackage-list.component';
import { TourpackageDetailComponent } from './pages/tourpackage-detail/tourpackage-detail.component';
import { HandicraftListComponent } from './pages/handicraft-list/handicraft-list.component';
import { HandicraftDetailComponent } from './pages/handicraft-detail/handicraft-detail.component';
import { HandicraftCategoryListComponent } from './pages/handicraft-category-list/handicraft-category-list.component';
import { PaintingListComponent } from './pages/painting-list/painting-list.component';
import { PaintingDetailComponent } from './pages/painting-detail/painting-detail.component';
import { PaintingCategoryListComponent } from './pages/painting-category-list/painting-category-list.component';
import { PopularBusinessListComponent } from './pages/popular-business-list/popular-business-list.component';
import { PopularBusinessCategoryListComponent } from './pages/popular-business-category-list/popular-business-category-list.component';
import { StoreProductListComponent } from './pages/store-product-list/store-product-list.component';
import { StoreProductDetailComponent } from './pages/store-product-detail/store-product-detail.component';
import { PrivacyPolicyComponent } from './pages/info/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './pages/info/terms-conditions/terms-conditions.component';
import { GovernmentTerritoryListComponent } from './pages/government-territory-list/government-territory-list.component';
import { AdminBusinessDetailComponent } from './pages/admin-business-detail/admin-business-detail.component';
import { AdminGovernmentDetailComponent } from './pages/admin-government-detail/admin-government-detail.component';

//import { AuthGuard } from './services/auth.guard';
//import { PeopleResolver } from './services/people.resolver';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['people/login']);
const redirectLoggedInToPeopleDetails = () => redirectLoggedInTo(['people/:id']);

const routes: Routes = [
  { path: '', component: PageHomeComponent },
  
  // ################ People
  { path: 'people/login', component: PeopleLoginComponent, 
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectLoggedInToPeopleDetails} 
  },
  { path: 'people/add', component: PeopleAddComponent, 
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectLoggedInToPeopleDetails} 
  },
  { path: 'people/:id', component: PeopleDetailsComponent, 
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectUnauthorizedToLogin} 
  },
  { path: 'people/update/details', component: PeopleUpdateDetailsComponent, 
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectUnauthorizedToLogin} 
  },

  // ################ Admin's Business Page
  // { path: 'admin/business/:id', component: AdminBusinessDetailComponent,
  // canActivate: [AngularFireAuthGuard], 
  // data: {authGuardPipe: redirectUnauthorizedToLogin} 
  // },
  { path: 'admin/business/:id', 
    component: AdminBusinessDetailComponent,
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectUnauthorizedToLogin} 
  },
  { path: 'admin/government/:id', 
    component: AdminGovernmentDetailComponent,
    canActivate: [AngularFireAuthGuard], 
    data: {authGuardPipe: redirectUnauthorizedToLogin} 
  },

  // ################ Sponsor
  { path: 'sponsors', component: SponsorListComponent},
  { path: 'sponsor/:id', component: SponsorDetailComponent},

  // ################ Business
  { path: 'business/categories', component: BusinessCategoryListComponent},
  { path: 'popular/businesses', component: PopularBusinessListComponent},
  { path: 'popular/business/categories', component: PopularBusinessCategoryListComponent},
  { path: 'businesses/:id', component: BusinessListComponent},
  { path: 'business/:id', component: BusinessDetailComponent},

  
  
  // ################ Government
  { path: 'government/categories', component: GovernmentCategoryListComponent},
  { path: 'provinces/:id', component: GovernmentTerritoryListComponent},

  { path: 'governments/:id', component: GovernmentListComponent}, 
  { path: 'government/:id', component: GovernmentDetailComponent},
  
  // ################ Tour Package
  { path: 'tourpackages', component: TourpackageListComponent},
  { path: 'tourpackage/:id', component: TourpackageDetailComponent},
  { path: 'tourpackage/categories', component: BusinessCategoryListComponent},

  // ################ Store Product
  { path: 'storeproducts', component: StoreProductListComponent},
  { path: 'storeproduct/:id', component: StoreProductDetailComponent},

  // ################ Handicraft
  { path: 'handicrafts', component: HandicraftListComponent},
  { path: 'handicraft/:id', component: HandicraftDetailComponent},
  { path: 'handicraft/categories', component: HandicraftCategoryListComponent},

  // ################ Painting
  { path: 'paintings', component: PaintingListComponent},
  { path: 'painting/:id', component: PaintingDetailComponent},
  { path: 'painting/categories', component: PaintingCategoryListComponent},
  
  // ################ Pages
  { path: 'search', component: PageSearchComponent },
  { path: 'settings', component: PageSettingComponent },
  { path: 'helps', component: PageHelpComponent },
  { path: 'legal/privacy', component: PrivacyPolicyComponent },
  { path: 'legal/terms', component: TermsConditionsComponent },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }